import { Component, Input, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-image-lazy-loading',
  templateUrl: './image-lazy-loading.component.html',
  styleUrls: ['./image-lazy-loading.component.scss']
})
export class ImageLazyLoadingComponent implements OnInit {
  @Input() loader: string = 'https://media.giphy.com/media/y1ZBcOGOOtlpC/200.gif';
  @Input() height: any;
  @Input() width: number;
  @Input() heightMobile: any;

  @Input() widthMobile: any;

  @Input() image: any;
  @Input() name: any;
  @Input() type: any="'carousel'";

  @Input() imageType: any=1;
  @Input() radius: any;
  public serverPath7 = environment.commonImageApi+"catalog/product/";

  public serverPath8 = environment.commonImageApi+"catalog/product";

  isLoading: boolean;
  // Whether the image has finished loading successfully (or errored)
  public isLoaded: boolean = false;
  // Whether to show the skeleton placeholder
  public showSkeleton: boolean = false;
  /** Delay before showing the skeleton (ms). Keeps UI from flickering on fast loads. */
  @Input() skeletonDelayMs: number = 80;
  /** Maximum time to wait for the image to load before giving up (ms). */
  @Input() loadTimeoutMs: number = 15000;
  /** Force showing the skeleton immediately when the image becomes visible. */
  @Input() forceSkeleton: boolean = false;
  actualImage: any;
  @ViewChild('lazyImg', { static: true }) lazyImg!: ElementRef<HTMLImageElement>;
  private observer: IntersectionObserver | null = null;
  public isVisible = false;
  private skeletonTimer: any = null;
  private loadTimer: any = null;
  constructor(private sanitizer: DomSanitizer ) {
    this.isLoading = false;
    
  }

  onImageError(event: Event, fallback: string) {
    const img = event && event.target as HTMLImageElement;
    if (img) {
      try { img.src = fallback; } catch (e) { /* ignore */ }
      // Ensure we stop showing the skeleton and mark as loaded so placeholder is visible
      this.clearTimers();
      this.showSkeleton = false;
      this.isLoaded = true;
    }
  }

  hideLoader() {
    this.isLoading = false;
  }
  ngOnInit() {
    this.height=this.height

    if( this.image!=null){
      this.image=this.image.replace("///","/");
      
    if(this.image.includes('/http')){
     
      let array=[];
      array=this.image.split('/http');

      this.image="http"+array[1];

    }
   else if(this.image.includes('/medicineimages')){

      let array=[];
      array=this.image.split('/medicineimages');
      this.image=environment.commonImageApiNew+'medicineimages/'+array[1]
      
      
    }
    else if(this.image.includes('/commonimages')){

      let array=[];
      array=this.image.split('/commonimages');
      
      this.image=this.serverPath7+'commonimages/'+array[1]
      
      
    }

    else if(this.image.includes('/commonimages')){

      let array=[];
      array=this.image.split('/commonimages');
      
      this.image=this.serverPath8+'commonimages/'+array[1]
      
      
    }

    }
   


     
  
     
    if( this.type!='carousel'){
      this.type="product"
    }
    

   
  }

  ngAfterViewInit(): void {
    // set up IntersectionObserver on the image wrapper
    try {
      const el = this.lazyImg && this.lazyImg.nativeElement ? this.lazyImg.nativeElement : null;
      if (!el) return;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.isVisible = true;
              // Start the skeleton-delay timer and the overall load timeout
              this.startSkeletonAndLoadTimers();
              this.observer?.disconnect();
              this.observer = null;
            }
          });
        }, { root: null, rootMargin: '200px', threshold: 0.01 });
        this.observer.observe(el);
      } else {
        this.isVisible = true;
        // Start skeleton/show timers even if IntersectionObserver is not available
        this.startSkeletonAndLoadTimers();
      }
    } catch (e) {
      this.isVisible = true;
      this.isLoading = true;
    }
  }
  onLoaded() {
    // Image finished loading
    this.clearTimers();
    this.isLoaded = true;
    this.showSkeleton = false;
  }

  private startSkeletonAndLoadTimers() {
    // Reset flags
    this.isLoaded = false;
    this.showSkeleton = false;

    // If forceSkeleton is set, show the skeleton immediately
    if (this.forceSkeleton) {
      this.showSkeleton = true;
    } else {
      // Delay showing the skeleton to avoid flicker on fast loads
      if (this.skeletonDelayMs > 0) {
        this.skeletonTimer = setTimeout(() => {
          this.showSkeleton = true;
        }, this.skeletonDelayMs);
      } else {
        this.showSkeleton = true;
      }
    }

    // Set an overall timeout so we don't show the spinner forever
    if (this.loadTimeoutMs > 0) {
      this.loadTimer = setTimeout(() => {
        // Give up: hide the skeleton and mark as loaded so UI shows placeholder or broken image
        this.showSkeleton = false;
        this.isLoaded = true;
        this.clearTimers();
      }, this.loadTimeoutMs);
    }
  }

  private clearTimers() {
    try { if (this.skeletonTimer) { clearTimeout(this.skeletonTimer); this.skeletonTimer = null; } } catch (e) {}
    try { if (this.loadTimer) { clearTimeout(this.loadTimer); this.loadTimer = null; } } catch (e) {}
  }



  

}
